var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"info"},[_c('div',{staticClass:"info-left"},[_c('img',{attrs:{"width":"72","src":_vm.userImg}}),_c('div',{staticClass:"info-left-info"},[_c('div',{staticClass:"info-left-top title"},[_vm._v(" "+_vm._s(_vm.name)+"，欢迎使用 浦江工业 | BUND Industries ™ 企业资源管理系统 ")])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }